import * as z from 'zod';

import { normalizeCountryCode } from '../../validations/CountryCodes';
import { pii } from './pii';

export type ExportableAddress = z.infer<typeof ExportableAddress>;
// Street lines identify an individual's location, so mark them PII. City/region/postcode/country
// are geographic quasi-identifiers, not individually PII, and are left unmarked.
export const ExportableAddress = z.object({
  line1: pii(z.string()),
  line2: pii(z.string().optional()),
  line3: pii(z.string().optional()),
  line4: pii(z.string().optional()),
  locality: z.string(),
  region: z.string(),
  postcode: z.string(),
  county: z.string().optional(),
  country: z.string().transform(normalizeCountryCode),
});
